import $dctRs$arAEmodulejs from "./ar-AE.mjs";
import $dctRs$bgBGmodulejs from "./bg-BG.mjs";
import $dctRs$csCZmodulejs from "./cs-CZ.mjs";
import $dctRs$daDKmodulejs from "./da-DK.mjs";
import $dctRs$deDEmodulejs from "./de-DE.mjs";
import $dctRs$elGRmodulejs from "./el-GR.mjs";
import $dctRs$enUSmodulejs from "./en-US.mjs";
import $dctRs$esESmodulejs from "./es-ES.mjs";
import $dctRs$etEEmodulejs from "./et-EE.mjs";
import $dctRs$fiFImodulejs from "./fi-FI.mjs";
import $dctRs$frFRmodulejs from "./fr-FR.mjs";
import $dctRs$heILmodulejs from "./he-IL.mjs";
import $dctRs$hrHRmodulejs from "./hr-HR.mjs";
import $dctRs$huHUmodulejs from "./hu-HU.mjs";
import $dctRs$itITmodulejs from "./it-IT.mjs";
import $dctRs$jaJPmodulejs from "./ja-JP.mjs";
import $dctRs$koKRmodulejs from "./ko-KR.mjs";
import $dctRs$ltLTmodulejs from "./lt-LT.mjs";
import $dctRs$lvLVmodulejs from "./lv-LV.mjs";
import $dctRs$nbNOmodulejs from "./nb-NO.mjs";
import $dctRs$nlNLmodulejs from "./nl-NL.mjs";
import $dctRs$plPLmodulejs from "./pl-PL.mjs";
import $dctRs$ptBRmodulejs from "./pt-BR.mjs";
import $dctRs$ptPTmodulejs from "./pt-PT.mjs";
import $dctRs$roROmodulejs from "./ro-RO.mjs";
import $dctRs$ruRUmodulejs from "./ru-RU.mjs";
import $dctRs$skSKmodulejs from "./sk-SK.mjs";
import $dctRs$slSImodulejs from "./sl-SI.mjs";
import $dctRs$srSPmodulejs from "./sr-SP.mjs";
import $dctRs$svSEmodulejs from "./sv-SE.mjs";
import $dctRs$trTRmodulejs from "./tr-TR.mjs";
import $dctRs$ukUAmodulejs from "./uk-UA.mjs";
import $dctRs$zhCNmodulejs from "./zh-CN.mjs";
import $dctRs$zhTWmodulejs from "./zh-TW.mjs";

var $865c2eb7c00a83f1$exports = {};


































$865c2eb7c00a83f1$exports = {
    "ar-AE": $dctRs$arAEmodulejs,
    "bg-BG": $dctRs$bgBGmodulejs,
    "cs-CZ": $dctRs$csCZmodulejs,
    "da-DK": $dctRs$daDKmodulejs,
    "de-DE": $dctRs$deDEmodulejs,
    "el-GR": $dctRs$elGRmodulejs,
    "en-US": $dctRs$enUSmodulejs,
    "es-ES": $dctRs$esESmodulejs,
    "et-EE": $dctRs$etEEmodulejs,
    "fi-FI": $dctRs$fiFImodulejs,
    "fr-FR": $dctRs$frFRmodulejs,
    "he-IL": $dctRs$heILmodulejs,
    "hr-HR": $dctRs$hrHRmodulejs,
    "hu-HU": $dctRs$huHUmodulejs,
    "it-IT": $dctRs$itITmodulejs,
    "ja-JP": $dctRs$jaJPmodulejs,
    "ko-KR": $dctRs$koKRmodulejs,
    "lt-LT": $dctRs$ltLTmodulejs,
    "lv-LV": $dctRs$lvLVmodulejs,
    "nb-NO": $dctRs$nbNOmodulejs,
    "nl-NL": $dctRs$nlNLmodulejs,
    "pl-PL": $dctRs$plPLmodulejs,
    "pt-BR": $dctRs$ptBRmodulejs,
    "pt-PT": $dctRs$ptPTmodulejs,
    "ro-RO": $dctRs$roROmodulejs,
    "ru-RU": $dctRs$ruRUmodulejs,
    "sk-SK": $dctRs$skSKmodulejs,
    "sl-SI": $dctRs$slSImodulejs,
    "sr-SP": $dctRs$srSPmodulejs,
    "sv-SE": $dctRs$svSEmodulejs,
    "tr-TR": $dctRs$trTRmodulejs,
    "uk-UA": $dctRs$ukUAmodulejs,
    "zh-CN": $dctRs$zhCNmodulejs,
    "zh-TW": $dctRs$zhTWmodulejs
};


export {$865c2eb7c00a83f1$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
